import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgYelpLogoSmall = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__yelp-logo-small_svg__a)">
        <path
          d="M2.99 10a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-14 0Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__yelp-logo-small_svg__b)"
        />
        <path
          d="m8.707 11.102.453-.104c.01-.003.024-.005.045-.012a.5.5 0 0 0 .357-.595l-.002-.008a.507.507 0 0 0-.076-.168.645.645 0 0 0-.185-.159 1.696 1.696 0 0 0-.262-.122l-.498-.18a47.264 47.264 0 0 0-.838-.302c-.182-.065-.336-.122-.472-.163l-.076-.023a1.364 1.364 0 0 0-.373-.071.449.449 0 0 0-.352.15 1.187 1.187 0 0 0-.064.08c-.02.03-.036.06-.052.09a.94.94 0 0 0-.044.1 2.573 2.573 0 0 0-.135.846c.001.26.01.593.152.819.034.057.08.108.135.147.101.07.205.08.312.088.16.01.314-.027.469-.063l1.506-.35Zm5.05-2.402a2.534 2.534 0 0 0-.493-.7.821.821 0 0 0-.261-.174.485.485 0 0 0-.197-.033.461.461 0 0 0-.184.052c-.086.043-.18.112-.304.227l-.059.055c-.102.096-.216.215-.351.353-.21.212-.416.423-.62.64l-.367.38c-.067.07-.129.145-.183.224a.637.637 0 0 0-.098.223.524.524 0 0 0 .005.184l.001.008a.497.497 0 0 0 .215.307c.108.07.239.095.366.07.02-.002.036-.006.045-.007l1.957-.452c.154-.035.31-.068.45-.149a.567.567 0 0 0 .241-.214.47.47 0 0 0 .058-.192c.03-.265-.11-.568-.222-.802Zm-3.502.823c.142-.178.14-.443.153-.66.043-.725.088-1.45.122-2.174.014-.275.042-.546.026-.822-.014-.228-.015-.49-.16-.678-.255-.331-.799-.304-1.168-.252a4.617 4.617 0 0 0-.674.156c-.355.116-.854.33-.939.74-.048.23.066.467.153.68.107.255.252.486.384.727.35.635.707 1.267 1.063 1.9.106.189.221.428.428.526a.495.495 0 0 0 .578-.11.4.4 0 0 0 .034-.033Zm-.17 1.94a.454.454 0 0 0-.505-.17c-.022.007-.043.017-.063.026a.54.54 0 0 0-.09.056c-.081.06-.15.14-.212.218-.017.02-.03.046-.05.064l-.314.432c-.178.242-.354.485-.53.731-.113.16-.211.294-.289.413-.015.022-.03.048-.044.067a1.28 1.28 0 0 0-.172.343.442.442 0 0 0-.02.193.478.478 0 0 0 .068.192l.061.085a.848.848 0 0 0 .159.146 2.764 2.764 0 0 0 1.35.466.763.763 0 0 0 .214-.018 1.21 1.21 0 0 0 .1-.029.48.48 0 0 0 .17-.109.448.448 0 0 0 .105-.163c.037-.09.06-.205.075-.376.001-.024.005-.053.007-.08.012-.142.017-.308.027-.505.015-.3.027-.6.037-.9l.02-.535c.005-.123 0-.26-.034-.382a.524.524 0 0 0-.07-.165Zm3.554.835a1.329 1.329 0 0 0-.306-.232 1.841 1.841 0 0 1-.069-.041c-.121-.074-.27-.15-.441-.245a54.59 54.59 0 0 0-.796-.426l-.472-.25c-.024-.007-.049-.025-.072-.036a1.179 1.179 0 0 0-.287-.103.666.666 0 0 0-.171-.007.452.452 0 0 0-.37.553c.023.126.079.249.136.358l.252.472c.14.266.283.53.427.794.095.172.173.319.245.441.014.024.03.048.041.069.089.146.16.24.234.305.046.045.104.08.165.101.065.022.134.029.201.022a.897.897 0 0 0 .103-.018c.033-.01.067-.02.098-.031a.846.846 0 0 0 .101-.047 2.756 2.756 0 0 0 1.009-1.01.742.742 0 0 0 .078-.2.895.895 0 0 0 .018-.102.477.477 0 0 0-.023-.201.43.43 0 0 0-.101-.166Z"
          fill="#fff"
        />
      </g>
      <defs>
        <radialGradient
          id="src__com__yext__listingslaunchstorm__public__icons__yelp-logo-small_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(90 4.31 5.681) scale(16.7174)"
        >
          <stop stopColor="#FF78A1" />
          <stop offset={0.513} stopColor="#FE375C" />
          <stop offset={1} stopColor="red" />
        </radialGradient>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__yelp-logo-small_svg__a">
          <path fill="#fff" transform="translate(3 3)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgYelpLogoSmall;
